export default "__VITE_ASSET__69RXMRGI__"